import script from "./PaymentServiceIndex.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentServiceIndex.vue?vue&type=script&lang=ts&setup=true"

import "./PaymentServiceIndex.vue?vue&type=style&index=0&id=5e51bddf&scoped=true&lang=scss"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e51bddf"]])

export default __exports__